'use strict'

import {createScapiFetch} from './utils'

class EmailMgr {
    constructor(config) {
        this.config = config
        this.fetch = createScapiFetch(config)
    }

    /**
     * Sends an email using the specified parameters and access token.
     *
     * @async
     * @param {Object} parameters - The parameters required to send the email.
     * @param {string} [parameters.emailID=''] - The ID of the email template to be used.
     * @param {string} [parameters.emailType=''] - The type of email to be sent.
     * @param {string} [parameters.token=''] - A token for email personalization or tracking.
     * @param {Object} [parameters.context={}] - Additional context for the email content.
     * @param {string} [parameters.firstName=''] - The recipient's first name.
     * @param {string} [parameters.lastName=''] - The recipient's last name.
     * @param {string} [parameters.stateCode=''] - The state code relevant to the email.
     * @param {string} [parameters.orderNo=''] - The order number associated with the email.
     * @param {string} accessToken - The access token for authentication with the email API.
     * @returns {Promise<Object>} A promise that resolves to the response from the email API, or an empty object if the response is undefined.
     * @throws {Error} Throws an error if the email sending process fails.
     */
    async sendEmail(parameters, accessToken) {
        let params = {
            querystring: {}
        }

        let body = {
            ...parameters,
            emailID: parameters.emailID || '',
            emailType: parameters.emailType || '',
            token: parameters.token || '',
            context: parameters.context || {},
            firstName: parameters.firstName || '',
            lastName: parameters.lastName || '',
            stateCode: parameters.stateCode || '',
            orderNo: parameters.orderNo || ''
        }

        let endpoint = 'send'
        let method = 'POST'
        let args = [params]
        let methodName = 'sendEmail'
        let apiVersion = 'v1'
        let requestParams = {
            body: body,
            accessToken: accessToken,
            isCached: false,
            apiPath: 'send-email'
        }

        try {
            let sendEmailResponse = await this.fetch(
                endpoint,
                method,
                args,
                methodName,
                requestParams,
                apiVersion
            )

            return sendEmailResponse || {}
        } catch (error) {
            throw new Error('Error sending email')
        }
    }
}

export default EmailMgr
